import { useState, useEffect, useCallback } from 'react';
import { isMobileDevice } from '@/utils/device';
import { isLandscape } from '@/utils/device';

/**
 * Reactive hook that returns whether the device is mobile.
 * Re-evaluates on resize and orientation change so the UI
 * re-renders when switching between portrait and landscape.
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => isMobileDevice());

  const handleChange = useCallback(() => {
    setIsMobile(isMobileDevice() && !isLandscape());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleChange);
    window.addEventListener('orientationchange', handleChange);

    // Some browsers fire orientationchange before the resize completes
    const handleOrientationWithDelay = () => {
      setTimeout(handleChange, 100);
    };
    window.addEventListener('orientationchange', handleOrientationWithDelay);

    return () => {
      window.removeEventListener('resize', handleChange);
      window.removeEventListener('orientationchange', handleChange);
      window.removeEventListener('orientationchange', handleOrientationWithDelay);
    };
  }, [handleChange]);

  return isMobile;
};
